// extracted by mini-css-extract-plugin
export default {"modalContainer":"style_modalContainer__r3Obw","title":"style_title__8+f56","description":"style_description__aCMz9","btn":"style_btn__Em5pW"};